import Icon from "vue-awesome/components/Icon";

import "vue-awesome/icons/cloud-upload-alt";
import "vue-awesome/icons/mobile-alt";
import "vue-awesome/icons/tablet-alt";
import "vue-awesome/icons/desktop";
import "vue-awesome/icons/chevron-down";
import "vue-awesome/icons/chevron-up";
import "vue-awesome/icons/chevron-left";
import "vue-awesome/icons/chevron-right";
import "vue-awesome/icons/envelope";
import "vue-awesome/icons/envelope-open-text";
import "vue-awesome/icons/users";
import "vue-awesome/icons/user-tag";
import "vue-awesome/icons/user-check";
import "vue-awesome/icons/times";
import "vue-awesome/icons/paper-plane";
import "vue-awesome/icons/pen-fancy";
import "vue-awesome/icons/spinner";
import "vue-awesome/icons/check-circle";
import "vue-awesome/icons/times-circle";
import "vue-awesome/icons/pencil-alt";
import "vue-awesome/icons/check";
import "vue-awesome/icons/archive";
import "vue-awesome/icons/exclamation-circle";
import "vue-awesome/icons/bars";
import "vue-awesome/icons/info-circle";
import "vue-awesome/icons/user-astronaut";
import "vue-awesome/icons/rocket";
import "vue-awesome/icons/star";
import "vue-awesome/icons/unlink";
import "vue-awesome/icons/link";
import "vue-awesome/icons/caret-down";
import "vue-awesome/icons/caret-up";
import "vue-awesome/icons/caret-left";
import "vue-awesome/icons/caret-right";
import "vue-awesome/icons/download";
import "vue-awesome/icons/question";
import "vue-awesome/icons/comments";
import "vue-awesome/icons/sign-out-alt";
import "vue-awesome/icons/palette";
import "vue-awesome/icons/angle-left";
import "vue-awesome/icons/angle-right";
import "vue-awesome/icons/folder";
import "vue-awesome/icons/plus-circle";
import "vue-awesome/icons/plus";
import "vue-awesome/icons/question";
import "vue-awesome/icons/list";
import "vue-awesome/icons/regular/surprise";
import "vue-awesome/icons/regular/credit-card";
import "vue-awesome/icons/regular/star";
import "vue-awesome/icons/bell";
import "vue-awesome/icons/images";
import "vue-awesome/icons/lock";
import "vue-awesome/icons/regular/question-circle";

Icon.register({
  promo: {
    width: 288,
    height: 186,
    paths: [
      {
        style: "fill:#fff;stroke:#3D4852;stroke-width:10.557",
        d:
          "M43.361 21.367l189.363-12.65c7.462-.499 12.741-.847 16.893-.786 4.09.06 6.618.523 8.641 1.386a21.31 21.31 0 019.882 8.588c1.137 1.883 1.948 4.322 2.578 8.363.64 4.103 1.031 9.38 1.579 16.838l6.006 81.887c.547 7.458.93 12.735.896 16.883-.034 4.086-.481 6.609-1.332 8.625a20.918 20.918 0 01-8.532 9.818c-1.878 1.123-4.313 1.918-8.354 2.521-4.103.613-9.382.97-16.843 1.468L54.775 176.959c-7.462.498-12.741.847-16.893.786-4.09-.061-6.618-.524-8.641-1.387a21.316 21.316 0 01-9.883-8.587c-1.136-1.884-1.947-4.322-2.578-8.364-.64-4.103-1.03-9.379-1.578-16.837L9.196 60.682c-.547-7.458-.93-12.735-.896-16.883.034-4.086.481-6.608 1.332-8.624a20.915 20.915 0 018.532-9.818c1.878-1.124 4.313-1.918 8.354-2.522 4.103-.613 9.382-.97 16.843-1.468z",
      },
      {
        style: "fill:#3D4852;fill-opacity:.8",
        d:
          "M13.049 58.547c-2.363-1.722-5.665-1.213-7.374 1.138-1.71 2.35-1.179 5.652 1.184 7.374l6.19-8.512zm262.487-10.483c2.079-2.03 2.107-5.37.063-7.46-2.045-2.091-5.389-2.14-7.469-.11l7.406 7.57zM9.954 62.804C6.86 67.058 6.86 67.06 6.862 67.06l.004.003.014.01.052.038a120.23 120.23 0 00.947.68c.657.47 1.62 1.152 2.86 2.016 2.48 1.73 6.07 4.189 10.531 7.127 8.915 5.872 21.336 13.674 35.348 21.379 13.995 7.696 29.676 15.351 45.097 20.88 15.332 5.498 30.853 9.061 44.377 8.156l-.771-10.529c-11.393.762-25.3-2.252-40.093-7.557-14.706-5.273-29.848-12.647-43.561-20.188-13.698-7.532-25.87-15.176-34.622-20.94a475.54 475.54 0 01-10.298-6.97 305.486 305.486 0 01-3.47-2.454l-.176-.127-.041-.03-.01-.007-.001-.001-3.095 4.256zm136.138 64.546c13.538-.905 28.418-6.573 42.829-14.156 14.497-7.628 28.951-17.426 41.73-27.04 12.794-9.624 23.999-19.133 32.002-26.231a480.18 480.18 0 009.427-8.576 308.442 308.442 0 003.217-3.051l.174-.169.046-.045.013-.012.004-.004c.001 0 .002-.002-3.701-3.787s-3.702-3.786-3.702-3.786l-.002.002-.008.008-.037.036-.156.15a306.187 306.187 0 01-3.093 2.934 472.21 472.21 0 01-9.221 8.389c-7.859 6.97-18.841 16.287-31.35 25.698-12.523 9.421-26.486 18.866-40.31 26.14-13.909 7.318-27.254 12.21-38.633 12.971l.771 10.529z",
      },
      {
        style: "fill:#D8D8D8;fill-rule:evenodd;clip-rule:evenodd",
        d:
          "M169.925 61.051a12.366 12.366 0 0111.536-13.276l.689-.046c6.882-.454 12.875 4.752 13.385 11.63A12.365 12.365 0 01184 72.636l-.689.045c-6.882.455-12.875-4.752-13.386-11.63zM127.112 63.996a12.365 12.365 0 0111.536-13.277l.689-.046c6.881-.454 12.874 4.753 13.385 11.63a12.365 12.365 0 01-11.536 13.277l-.689.046c-6.881.454-12.874-4.753-13.385-11.63zM84.299 66.94a12.365 12.365 0 0111.536-13.277l.689-.045c6.881-.455 12.874 4.752 13.385 11.63a12.365 12.365 0 01-11.536 13.276l-.689.046c-6.882.455-12.874-4.752-13.385-11.63z",
      },
    ],
  },
});

Icon.register({
  shopify: {
    width: 109.5,
    height: 124.5,
    paths: [
      {
        style: "fill:#95bf47",
        d:
          "M95.9 24.2c-.1-.6-.6-1-1.1-1l-10-.7-7.4-7.3c-.7-.7-2.2-.5-2.7-.3L71 16C68.8 9.6 64.9 3.7 58 3.7h-.6C55.4 1.1 53 0 50.9 0 34.8 0 27.1 20.1 24.7 30.3l-11.2 3.5c-3.5 1.1-3.6 1.2-4 4.5L0 111.2l71 13.3 38.5-8.3-13.6-92zm-28.9-7l-6 1.9v-1.3c0-4-.6-7.2-1.4-9.7 3.6.4 5.9 4.4 7.4 9.1zM55.2 8.8c1 2.5 1.6 6 1.6 10.8v.7l-12.4 3.8c2.4-9.1 6.9-13.6 10.8-15.3zm-4.8-4.5c.7 0 1.4.2 2.1.7-5.1 2.4-10.7 8.5-13 20.7l-9.8 3c2.7-9.3 9.2-24.4 20.7-24.4z",
      },
      {
        style: "fill:#5e8e3e",
        d:
          "M94.8 23.2l-10-.7-7.4-7.3a2 2 0 0 0-1-.5L71 124.5l38.5-8.3-13.6-91.9c-.1-.7-.7-1-1.1-1.1z",
      },
      {
        style: "fill:#fff",
        d:
          "M57.9 44.5l-4.7 14.1S49 56.4 44 56.4c-7.5 0-7.8 4.7-7.8 5.9 0 6.4 16.8 8.9 16.8 24 0 11.9-7.5 19.5-17.7 19.5-12.2 0-18.4-7.6-18.4-7.6l3.3-10.8s6.4 5.5 11.8 5.5c3.5 0 5-2.8 5-4.8 0-8.4-13.8-8.8-13.8-22.6 0-11.6 8.3-22.9 25.2-22.9 6.3 0 9.5 1.9 9.5 1.9z",
      },
    ],
  },
});

export default Icon;
